import styles from './Feature.module.scss';
import CharacterImage from '../../assets/images/feature1_1.png';
import AppImage from '../../assets/images/feature1_2.png';
import Cherry1 from '../../assets/images/feature1_3.png';
import Cherry2 from '../../assets/images/feature1_4.png';
import Bubble1 from '../../assets/images/feature1_5.png';
import Bubble2 from '../../assets/images/feature1_6.png';
import useMobile from '../../hooks/useMobile';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

const FadeInSection = ({
  delay = 0,
  children,
}: {
  delay?: number;
  children: React.ReactNode;
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true, // 한 번만 애니메이션 실행
    margin: '0px 0px -100px 0px', // 뷰포트에 들어오기 100px 전에 시작
  });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 100 }} // 시작: 투명하고 아래에 위치
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }} // 화면에 들어오면 원래 위치로
      transition={{ delay: delay, duration: 0.5, ease: 'easeOut' }} // 부드러운 애니메이션
      style={{
        position: 'relative',
        zIndex: 100,
      }}
    >
      {children}
    </motion.div>
  );
};

const Feature1 = () => {
  const { isMobile } = useMobile();
  if (isMobile)
    return (
      <div className={styles.mobile_wrapper}>
        <div className={styles.text_container}>
          <div className={styles.title}>
            설렘 넘치는 과몰입 상황극, <br /> 해 본 적 있나요?
          </div>
          <div className={styles.description}>
            원하는 성격, 스타일의 캐릭터와 원하는
            <br />
            스토리로 대화해보세요.
            <br />
            간질간질한 로맨스는 물론 다양한 상황극을 통해
            <br />
            도파민 넘치는 과몰입을 경험해보세요
          </div>
        </div>
        <div className={styles.img_container}></div>
        <img
          src={CharacterImage}
          alt="character"
          className={styles.character}
        />
        <img src={AppImage} alt="app" className={styles.app} />
        <img src={Cherry1} alt="cherry" className={styles.cherry1} />
        <img src={Cherry2} alt="cherry" className={styles.cherry2} />
        <img src={Bubble1} alt="bubble" className={styles.bubble1} />
        <img src={Bubble2} alt="bubble" className={styles.bubble2} />
      </div>
    );
  return (
    <div className={styles.wrapper}>
      <img src={CharacterImage} alt="character" className={styles.character} />
      <img src={AppImage} alt="app" className={styles.app} />
      <img src={Cherry1} alt="cherry" className={styles.cherry1} />
      <img src={Cherry2} alt="cherry" className={styles.cherry2} />
      <FadeInSection>
        <img src={Bubble1} alt="bubble" className={styles.bubble1} />
      </FadeInSection>
      <FadeInSection delay={0.5}>
        <img src={Bubble2} alt="bubble" className={styles.bubble2} />
      </FadeInSection>

      <div className={styles.container}></div>
      <div className={styles.container}>
        <div className={styles.title}>
          설렘 넘치는 과몰입 상황극, <br /> 해 본 적 있나요?
        </div>
        <div className={styles.description}>
          원하는 성격, 스타일의 캐릭터와 원하는 스토리로 대화해보세요.
          <br />
          간질간질한 로맨스는 물론 다양한 상황극을 통해
          <br />
          도파민 넘치는 과몰입을 경험해보세요
        </div>
      </div>
    </div>
  );
};

export default Feature1;
